import React from 'react'
import TabNavigation from '../../resultPage/tabNavigation'
import LoadingComponent from '../../../Components/LoadingComponent/loading'
import { fetchProjects, getProjectsByCategory } from '../../../services/projectService';
import useFetch from '../../../hooks/useFetch';
import { useParams } from 'react-router-dom';
import DatalistSection from './datalist';

const ProjectsSearchListPage = () => {

    const { query } = useParams();

    const { data: searchResults, loading, error } = useFetch(
        () => getProjectsByCategory("all-projects"),
        [query] // Dependency: Fetch again when URL changes
    );

    console.log("searchResults", searchResults, error)

    // Function to capitalize the first letter of each word in the string
    const capitalizeFirstLetter = (str) => {
        return str
            .split('-') // Split the string by hyphens
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter
            .join(' '); // Join the words back with a space
    };

    console.log("searchResults", searchResults);

    // Get the human-readable label for the current query

    const displayQuery = capitalizeFirstLetter(query);


    // Handle message based on loading, error, and response data
    let message;
    if (loading) {
        message = "Loading projects...";  // Updated message here
    } else if (error) {
        message = "Failed to load projects. Please try again.";  // Updated error message
    } else if (searchResults?.success === false) {
        // Handle the error response from getProjectsByCategory
        message = searchResults?.message || `No projects found for ${displayQuery} in Jaipur`;
    } else if (searchResults?.projects?.length === 0) {
        message = `No projects found for ${displayQuery} in Jaipur`;
    } else {
        message = `${searchResults?.projects?.length} projects available for ${displayQuery} in Jaipur`;
    }

    return (
        <div className='my-[150px]'>
            <div className='w-[78%] ml-5'>
                <TabNavigation resultTab1={"Projects"} totalResults={searchResults?.projects?.length} />
                <div className='py-4'>
                    <p className='text-[26px] font-normal'>
                        {message}
                    </p>
                </div>
                {loading ? (
                    <LoadingComponent />
                ) : error ? (
                    <p className='text-center text-lg text-red-500'>Error fetching services. Try refreshing the page.</p>
                ) : (
                    <DatalistSection projectesData={searchResults?.projects} />
                )}
            </div>
            <div className='w-[5%]'></div>
            <div className='w-[25%]'></div>
        </div>
    )
}

export default ProjectsSearchListPage